/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";

import { ImageLink, Container } from "./styles";

import telegram from "../../../static/media/Telegram.svg";
import facebook from "../../../static/media/Facebook.svg";
import linkedin from "../../../static/media/Linkedin.svg";
import twitter from "../../../static/media/Twitter.svg";

const ShareMiniComponent = () => {
  const [mainLink, setMainLink] = useState("");

  useEffect(() => {
    setMainLink(window.location.href);
  }, [window.location.href]);

  const imageSrc = [
    {
      image: linkedin,
      color: "#2A85B8",
      link: "http://www.linkedin.com/shareArticle?mini=true&url=" + mainLink,
    },
    {
      image: facebook,
      color: "#2251C9",

      link: "https://www.facebook.com/sharer/sharer.php?u=" + mainLink,
    },

    {
      image: telegram,
      link: "https://telegram.me/share/url?url=" + mainLink,
      color: "#2A85B8",
    },
    {
      image: twitter,
      link: "https://twitter.com/intent/tweet?text=" + mainLink,
      color: "#2A85B8",
    },
  ];

  return (
    <Container>
      <div className="h3"> Share it in social media</div>
      <div>
        {imageSrc.map((item, i) => {
          return (
            <noindex>
              <ImageLink
                target="_blank"
                rel="noopener noreferrer nofollow"
                style={
                  i === 0
                    ? { marginLeft: 0, backgroundColor: item.color }
                    : { backgroundColor: item.color }
                }
                href={item.link}
                key={i}
              >
                <img src={item.image} alt="img" />
              </ImageLink>
            </noindex>
          );
        })}
      </div>
    </Container>
  );
};

export default ShareMiniComponent;
